module.exports = __webpack_public_path__ + "static/media/ic-sms.e42e9fe1.svg";